// Autogenerated file
export const paymentMethodTypesEnum = {
    ByUnloading: "ByUnloading",
    ByScan: "ByScan",
    ByOriginal: "ByOriginal",
    ByRegistry: "ByRegistry",
};
export const paymentMethodTypes = [
    { label: "По выгрузке", value: "ByUnloading" },
    { label: "По сканам", value: "ByScan" },
    { label: "По оригиналам", value: "ByOriginal" },
    { label: "По реестру", value: "ByRegistry" },
];
